/* LabelMate – kompatibilitetskontroll v2 (etikettrullar + färgband).
 * Endast publika butiks-endpoints under Shopifys aktuella språkrot.
 * Ingen Admin API-token eller annan hemlighet. */
(function (root) {
  'use strict';

  var CONFIG = {
    // Skrivare: produkt-ID -> godkända modelltaggar (primär identifiering).
    PRINTERS: {
      '8864842318157': { name: 'N1', tags: ['N1', 'B18'] },
      '8864842383693': { name: 'M2_H', tags: ['M2_H'] },
      '8864843137357': { name: 'B1', tags: ['B1'] },
      '8911513485645': { name: 'D11_H', tags: ['D11_H'] },
      '9768636154189': { name: 'B31', tags: ['B31'] },
      '10057486303565': { name: 'B21 PRO', tags: ['B21_PRO'] },
      '10519545610573': { name: 'M3', tags: ['M3'] },
      '10566342246733': { name: 'K3_W', tags: ['K3_W'] },
      '10580067385677': { name: 'B2 PRO', tags: ['B2 PRO'] }
    },
    // Paket – ignoreras helt (högsta prioritet). Lägg till nya ID:n här.
    IGNORE_BUNDLES: [
      '10937269518669', // D11_H Startpaket
      '10937269551437', // B2 PRO Startpaket
      '10937269584205', // B21 PRO Startpaket
      '10508450136397', // Bag'n'Tag Viltmästaren – Komplettpaket
      '10508452135245', // Bag'n'Tag Efterjakten – Refillpaket
      '10509959528781', // Bag'n'Tag Storförbrukning – Refillpaket
      '10509963919693', // Bag'n'Tag Jaktlaget – Komplettpaket
      '10510382563661', // Köksfavoriter (B-serien)
      '10584731681101', // @reorganiseras favoriter – 4-pack etiketter
      '10510882144589'  // Kök & Skafferi (Niimbot B31)
    ],
    // Tillbehör som varken är etiketter eller färgband – kontrolleras inte.
    IGNORE_ACCESSORIES: [
      '10744655446349', // Förvaringslåda, 6 fack
      '10753510146381'  // Förvaringslåda, 12 fack
    ],
    MODEL_TAGS: ['B1', 'B18', 'B2 PRO', 'B21', 'B21_PRO', 'B31', 'B3S', 'B4', 'D101', 'D11',
      'D110', 'D11_H', 'K3_W', 'M2_H', 'M3', 'N1']
  };

  var I18N = {
    sv: { title: 'Kontrollera kompatibiliteten', one: 'Följande produkter passar inte till {printer} i din varukorg:', many: 'Följande produkter passar inte till någon av skrivarna i din varukorg:', outro: 'Köper du dem till en annan skrivare? Då kan du fortsätta som vanligt.', aria: 'Kompatibilitetsvarning' },
    da: { title: 'Kontrollér kompatibiliteten', one: 'Følgende produkter passer ikke til {printer} i din kurv:', many: 'Følgende produkter passer ikke til nogen af printerne i din kurv:', outro: 'Køber du dem til en anden printer? Så kan du fortsætte som normalt.', aria: 'Kompatibilitetsadvarsel' },
    de: { title: 'Kompatibilität prüfen', one: 'Die folgenden Produkte passen nicht zum {printer} in deinem Warenkorb:', many: 'Die folgenden Produkte passen zu keinem der Drucker in deinem Warenkorb:', outro: 'Kaufst du sie für einen anderen Drucker? Dann kannst du wie gewohnt fortfahren.', aria: 'Kompatibilitätshinweis' },
    en: { title: 'Check compatibility', one: 'The following products are not compatible with the {printer} in your cart:', many: 'The following products are not compatible with any of the printers in your cart:', outro: 'Buying them for a different printer? Then you can continue as usual.', aria: 'Compatibility warning' },
    es: { title: 'Comprueba la compatibilidad', one: 'Los siguientes productos no son compatibles con la {printer} de tu carrito:', many: 'Los siguientes productos no son compatibles con ninguna de las impresoras de tu carrito:', outro: '¿Los compras para otra impresora? Entonces puedes continuar con normalidad.', aria: 'Aviso de compatibilidad' },
    fi: { title: 'Tarkista yhteensopivuus', one: 'Seuraavat tuotteet eivät sovi ostoskorissasi olevaan tulostimeen {printer}:', many: 'Seuraavat tuotteet eivät sovi mihinkään ostoskorissasi olevista tulostimista:', outro: 'Ostatko ne toiseen tulostimeen? Voit jatkaa normaalisti.', aria: 'Yhteensopivuusvaroitus' },
    fr: { title: 'Vérifiez la compatibilité', one: 'Les produits suivants ne sont pas compatibles avec la {printer} de votre panier :', many: 'Les produits suivants ne sont compatibles avec aucune des imprimantes de votre panier :', outro: 'Vous les achetez pour une autre imprimante ? Vous pouvez continuer normalement.', aria: 'Avertissement de compatibilité' },
    nl: { title: 'Controleer de compatibiliteit', one: 'De volgende producten passen niet bij de {printer} in je winkelwagen:', many: 'De volgende producten passen bij geen van de printers in je winkelwagen:', outro: 'Koop je ze voor een andere printer? Dan kun je gewoon doorgaan.', aria: 'Compatibiliteitswaarschuwing' },
    no: { title: 'Kontroller kompatibiliteten', one: 'Følgende produkter passer ikke til {printer} i handlekurven din:', many: 'Følgende produkter passer ikke til noen av skriverne i handlekurven din:', outro: 'Kjøper du dem til en annen skriver? Da kan du fortsette som vanlig.', aria: 'Kompatibilitetsadvarsel' }
  };
  I18N.nb = I18N.no; I18N.nn = I18N.no;

  function normId(id) {
    if (id == null) return '';
    var m = String(id).match(/(\d+)\s*$/);
    return m ? m[1] : '';
  }
  function has(list, id) { return list.indexOf(id) !== -1; }

  function modelTagsOf(item) {
    return (item.tags || []).map(function (t) { return String(t).trim(); })
      .filter(function (t) { return has(CONFIG.MODEL_TAGS, t); });
  }

  /* Ren funktion. items: [{product_id, title, tags:[...]}]
   * Returnerar null eller {printers:[namn], products:[titel]} */
  function evaluate(items) {
    var printers = [], accepted = {}, out = [], seen = {};
    var rest = [];
    items.forEach(function (it) {
      var id = normId(it.product_id);
      if (has(CONFIG.IGNORE_BUNDLES, id) || has(CONFIG.IGNORE_ACCESSORIES, id)) return;
      var p = CONFIG.PRINTERS[id];
      if (p) {
        if (!has(printers, p.name)) printers.push(p.name);
        p.tags.forEach(function (t) { accepted[t] = true; });
      } else rest.push(it);
    });
    if (!printers.length) return null;
    rest.forEach(function (it) {
      var tags = modelTagsOf(it);
      if (!tags.length) return; // inga giltiga modelltaggar -> ingen varning
      if (tags.some(function (t) { return accepted[t]; })) return;
      var id = normId(it.product_id);
      if (!seen[id]) { seen[id] = true; out.push(it.title); }
    });
    return out.length ? { printers: printers, products: out } : null;
  }

  function pickLocale(code) {
    var c = String(code || '').toLowerCase();
    return I18N[c] || I18N[c.split('-')[0]] || I18N.sv;
  }

  /* Bygger rutan som DOM-noder (produktnamn sätts som textContent). */
  function buildBox(doc, result, locale) {
    var t = pickLocale(locale);
    var box = doc.createElement('div');
    box.className = 'lm-compat';
    box.setAttribute('role', 'status');
    box.setAttribute('aria-label', t.aria);
    function p(cls, text) { var e = doc.createElement('p'); e.className = cls; e.textContent = text; box.appendChild(e); }
    p('lm-compat__title', t.title);
    p('lm-compat__text', result.printers.length === 1 ? t.one.replace('{printer}', result.printers[0]) : t.many);
    var ul = doc.createElement('ul'); ul.className = 'lm-compat__list';
    result.products.forEach(function (n) { var li = doc.createElement('li'); li.textContent = n; ul.appendChild(li); });
    box.appendChild(ul);
    p('lm-compat__text', t.outro);
    return box;
  }

  var api = { CONFIG: CONFIG, I18N: I18N, evaluate: evaluate, normId: normId, pickLocale: pickLocale, buildBox: buildBox };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document === 'undefined' || !root.fetch) return;
  if (root.LabelMateCompat) return; // skript inläst två gånger
  root.LabelMateCompat = api;

  /* ---------- Butikskoppling ---------- */
  var origFetch = root.fetch.bind(root);
  var localeRoot = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
  if (localeRoot.slice(-1) !== '/') localeRoot += '/';
  function currentLocale() {
    var el = document.querySelector('[data-lm-compat][data-locale]');
    return (el && el.getAttribute('data-locale')) || (root.Shopify && root.Shopify.locale) || document.documentElement.lang || 'sv';
  }

  var tagCache = {};
  try {
    var seed = document.getElementById('lm-compat-seed');
    if (seed) JSON.parse(seed.textContent).forEach(function (p) { tagCache[normId(p.id)] = p.tags || []; });
  } catch (e) {}

  function tagsFor(item) {
    var id = normId(item.product_id);
    if (tagCache[id]) return Promise.resolve(tagCache[id]);
    var u = String(item.url || '').split('?')[0];
    var url = u.indexOf('/products/') !== -1 ? u : localeRoot + 'products/' + encodeURIComponent(item.handle);
    return origFetch(url + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
      .then(function (p) {
        var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
        tagCache[id] = tags; return tags;
      });
  }

  var seq = 0, lastResult = null;
  function paint() {
    var loc = currentLocale();
    document.querySelectorAll('[data-lm-compat]').forEach(function (el) {
      while (el.firstChild) el.removeChild(el.firstChild);
      if (lastResult) el.appendChild(buildBox(document, lastResult, loc));
    });
  }

  function check() {
    var my = ++seq;
    return origFetch(localeRoot + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (cart) {
        return Promise.all((cart.items || []).map(function (it) {
          return tagsFor(it).then(function (tags) {
            return { product_id: it.product_id, title: it.product_title || it.title, tags: tags };
          });
        }));
      })
      .then(function (items) { if (my !== seq) return; lastResult = evaluate(items); paint(); })
      .catch(function () { if (my !== seq) return; lastResult = null; paint(); }); // vid fel: ingen obekräftad varning
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(check, 150); }

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  root.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(root, arguments);
    if (CART_RE.test(url)) p.then(schedule, schedule);
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (CART_RE.test(String(url))) this.addEventListener('loadend', schedule);
    return xo.apply(this, arguments);
  };
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:open', 'cart-drawer:open', 'theme:cart:change']
    .forEach(function (ev) { document.addEventListener(ev, schedule); });
  if (root.subscribe && root.PUB_SUB_EVENTS && root.PUB_SUB_EVENTS.cartUpdate) root.subscribe(root.PUB_SUB_EVENTS.cartUpdate, schedule);

  // Temat ersätter varukorgens HTML: fyll nya tomma ytor direkt med senaste resultat och kontrollera igen.
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) for (var j = 0; j < muts[i].addedNodes.length; j++) {
      var n = muts[i].addedNodes[j];
      if (n.nodeType === 1 && (n.matches('[data-lm-compat]') || n.querySelector('[data-lm-compat]'))) { paint(); schedule(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });

  check();
})(typeof window !== 'undefined' ? window : globalThis);
